var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "enterAdjustmentModal",
        title: _vm.$t("adjustment_modal_title"),
        centered: "",
      },
      on: { hidden: _vm.clear },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "b-form",
        { staticClass: "enter-adjustment-form" },
        [
          _c(
            "info-row",
            {
              staticClass: "info-main-row",
              attrs: { title: _vm.$t("adjustment_modal_amount_label") },
            },
            [
              _c("currency-input", {
                attrs: {
                  name: _vm.$t("payment_modal_amount_label"),
                  amount: _vm.amount,
                  fieldState: _vm.fieldState.amount,
                },
                on: {
                  "update:amount": function ($event) {
                    _vm.amount = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "info-row",
            {
              staticClass: "info-main-row",
              attrs: { title: _vm.$t("description") },
            },
            [
              _c(
                "b-col",
                { staticClass: "input-group" },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: {
                      title: _vm.$t("description"),
                      type: "text",
                      required: "",
                    },
                    model: {
                      value: _vm.description,
                      callback: function ($$v) {
                        _vm.description = $$v
                      },
                      expression: "description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer",
        },
        [
          _c("span", { staticClass: "text-danger" }, [
            _vm._v(_vm._s(_vm.warningText)),
          ]),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              staticClass: "float-right",
              attrs: { variant: "success" },
              on: { click: _vm.submitAdjustment },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("adjustment_modal_button")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }